import { render, staticRenderFns } from "./AccountNoData.vue?vue&type=template&id=902cddf4"
import script from "./AccountNoData.vue?vue&type=script&lang=js"
export * from "./AccountNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports